import type { UIStringsOverride } from "../i18n-ui.ts";

/** Catalan (ca) UI strings. */
export const ca: UIStringsOverride = {
  actions: {
    addToCursor: "Afegeix a Cursor",
    addToVscode: "Afegeix a VS Code",
    askAI: "Pregunta a la IA sobre aquesta pàgina",
    connectMcp: "Connecta a MCP",
    copied: "Copiat!",
    copyClaudeCode: "Copia l'ordre de Claude Code",
    copyCode: "Copia el codi",
    copyCodex: "Copia l'ordre de Codex",
    copyMarkdown: "Copia com a Markdown",
    copyServerUrl: "Copia l'URL del servidor",
    edit: "Edita a GitHub",
    export: "Exporta",
    exportEpub: "Exporta a EPUB",
    exportPdf: "Exporta a PDF",
    generating: "S'està generant…",
    openIn: "Obre a {name}",
    openInChat: "Obre al xat",
    scrollToTop: "Torna a dalt",
  },
  ask: {
    ai: "IA",
    clear: "Esborra la conversa",
    close: "Tanca",
    copy: "Copia la conversa",
    empty: "Fes una pregunta sobre la documentació.",
    error: "Ho sentim, alguna cosa ha anat malament.",
    label: "Fes una pregunta",
    placeholder: "Fes una pregunta…",
    send: "Envia",
    tip: "Consell: pots obrir i tancar el xat amb",
    title: "Pregunta a la IA",
    you: "Tu",
  },
  banner: { dismiss: "Tanca l'anunci" },
  changelog: {
    description: "Actualitzacions del producte i notes de la versió.",
    showReleases: "Mostra les versions {version}",
    title: "Registre de canvis",
  },
  content: {
    diagramError: "No s'ha pogut mostrar aquest diagrama.",
  },
  feedback: {
    no: "No",
    question: "Aquesta pàgina t'ha estat útil?",
    thanks: "Gràcies pels teus comentaris!",
    yes: "Sí",
  },
  languageSwitcher: { label: "Idioma", untranslated: "Sense traduir" },
  nav: {
    back: "Enrere",
    breadcrumb: "Ruta de navegació",
    closeNavigation: "Tanca la navegació",
    deprecated: "obsolet",
    featured: "Destacat",
    githubRepository: "Repositori de GitHub",
    navigation: "Navegació",
    primary: "Principal",
    sections: "Seccions",
    toggleNavigation: "Mostra o amaga la navegació",
    toggleTheme: "Canvia el tema de color",
  },
  notFound: {
    description: "No hem pogut trobar la pàgina que cerques.",
    home: "Torna a l'inici",
    title: "Pàgina no trobada",
  },
  page: {
    lastUpdated: "Última actualització el",
    next: "Següent",
    pagination: "Paginació",
    previous: "Anterior",
    skipToContent: "Vés al contingut",
  },
  search: {
    all: "Tots",
    allLanguages: "Tots els idiomes",
    askAi: "Pregunta a la IA",
    askAiHint: "Obtén una resposta instantània de la IA",
    button: "Cerca",
    devOnly: "La cerca està disponible a la compilació de producció.",
    error: "Alguna cosa ha anat malament. Torna-ho a provar.",
    label: "Cerca a la documentació",
    navigate: "navega",
    noResults: "No s'ha trobat cap resultat.",
    open: "obre",
    placeholder: "Cerca a la documentació…",
    popular: "Populars",
    preview: "previsualitza",
    results: "Resultats",
  },
  toc: { title: "En aquesta pàgina" },
};
